import React from "react";
import { Modal, Button } from "react-bootstrap";

const DashaModal = ({
  isVisible,
  handleClose,
  handleBack,
  dasa_degreeldata,
  DashaName,
  dasa_degreelevel,
  SelectedDataDash,
  master_data_get_by_click,
  modalLevel,
}) => {
  return (
    <Modal show={isVisible} onHide={handleClose} size="lg" centered scrollable>
      <Modal.Header
        closeButton
        className="bg-white rounded-top justify-content-center"
      >
        <Modal.Title className="text-purple-700 font-semibold text-[15px] text-center w-100">
          {dasa_degreeldata || "Dasha Periods"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="bg-white p-2 custom-scrollbar">
        <div className="rounded-lg overflow-hidden shadow-sm">
          <table className="w-full text-sm text-center text-gray-800 min-w-[400px]">
            <thead>
              <tr className="text-[15px]">
                <th className="text-purple-700 fw-bold py-3 px-4 text-center">
                  Start Date
                </th>
                <th className="text-purple-700 fw-bold py-3 px-4 text-center">
                  {DashaName}
                </th>
                <th className="text-purple-700 fw-bold py-3 px-4 py-3 px-2 pr-4 text-center">
                  End Date
                </th>
              </tr>
            </thead>
            <tbody>
              {dasa_degreelevel?.length > 0 ? (
                dasa_degreelevel.map((item, index) => (
                  <tr
                    key={index}
                    className={`${
                      SelectedDataDash.startsWith(item.dasa)
                        ? "bg-orange-300"
                        : index % 2 === 0
                        ? "bg-gray-100"
                        : "bg-gray-50"
                    }  hover:bg-purple-100 transition-all duration-200 text-[14px]`}
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      master_data_get_by_click(
                        item.level_dasa,
                        item.dasa,
                        item.statdate,
                        item.endDate
                      )
                    }
                  >
                    <td className="py-3 px-2 pr-4 text-center">
                      {item.statdate}
                    </td>
                    <td className="py-3 px-2 pr-4 text-center">{item.dasa}</td>
                    <td className="py-3 px-2 pr-4 text-center">
                      {item.endDate}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className="text-center text-muted py-4">
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {modalLevel > 1 && (
          <Button
            className="cencelmodalCustmclss text-[15px] py-[9px] px-5"
            onClick={handleBack}
          >
            ← Back
          </Button>
        )}
        <Button
          className="bg-[var(--primary-color)] hover:bg-[var(--primary-hover-dark)] text-[12px] border-none py-[10px] px-5"
          variant="danger"
          onClick={handleClose}
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DashaModal;
